import Model from './model.js';

export default class EmploymentRecord extends Model
{
    constructor(id, personId, publishing, statisticalNumber, salary, retirementStatus, endorsementStatus, pensionNumber, dateAppointment, note){ 
        super()
        this.id                 = id ?? 0;
        this.personId           = personId;
        this.publishing         = publishing;
        this.statisticalNumber  = statisticalNumber;
        this.salary             = salary;
        this.retirementStatus   = retirementStatus;
        this.endorsementStatus  = endorsementStatus;
        this.pensionNumber      = pensionNumber;
        this.dateAppointment    = dateAppointment;
        this.note              = note;
        
        this.init()
    }

    update(data){
        Object.assign(this, data)
    }

    mapToUpdate(){
        let data =  {
            publishing:         this.publishing?.value ?? 0,
            statisticalNumber:  this.statisticalNumber ?? null,
            salary:             this.salary ?? null,
            retirementStatus:   this.retirementStatus?.value ?? 0,
            endorsementStatus:  this.endorsementStatus?.value ?? 0,
            dateAppointment:    this.dateAppointment ?? null,
            notes:              this.note ?? null,
            pensionNumber:      this.retirementStatus?.value == 1 ? (this.pensionNumber ?? null) : null,
        }
        return data;
    }

    mapToCreate(){
        let data = this.mapToUpdate();
        data.personId = this.personId ?? null;
        return data;
    }
}

